export default "__VITE_ASSET__DBAGk1oQ__"